import { useQuery } from '@tanstack/react-query';
import { CashAccountSource } from 'pco-product-service-internal-consumer';
import { getPortfolios } from 'services/portfolios/portfolioService';

const useGetPortfoliosList = (brUid: string, source: CashAccountSource = CashAccountSource.Crmch) => {
  return useQuery({
    queryKey: ['useGetPortfoliosList', brUid, source],
    queryFn: () => getPortfolios(brUid, source),
    enabled: !!brUid,
  });
};

export default useGetPortfoliosList;
